import { useCallback } from "react";

import {
  QA_CHARGING_MODAL_TAB,
  UI_MOLECULE_SWIPER_SLIDES,
} from "../../_common/modules/Data/static";
import { PAGE_CHARGING } from "../../_common/modules/fe-modules/Router/static";
import useGAViewScreen from "../../_common/modules/fe-modules/GA/useGAViewScreen";
import useGA from "../../_common/modules/fe-modules/GA/useGA";
import {
  GaEvent,
  GA_TOYOTA_FOR_YOU_CHARGING,
  GA_VEHICLE_CHARGING,
} from "../../_common/modules/fe-modules/GA/static";
import { stringSplitByHyphen } from "../../_common/helpers/utils";
import useCMSPageData from "../../_common/hooks/useCMSPageData";

export type UseChargingProps = {
  headerContent: any;
  mainContent: any;
  footerContent: any;
};

const useCharging = (): UseChargingProps => {
  const { triggerGAEvent } = useGA();

  const { data } = useCMSPageData({
    page: PAGE_CHARGING,
    queryKey: "chargingPage",
  });

  useGAViewScreen(GA_TOYOTA_FOR_YOU_CHARGING, GA_VEHICLE_CHARGING);

  // ********************
  // Data
  // ********************
  const getHeaderContent = useCallback(() => data?.containers?.header, [data]);

  const getMainContent = useCallback(
    () =>
      data?.containers?.main.map((component: any) => {
        if (component.type === UI_MOLECULE_SWIPER_SLIDES) {
          return {
            ...component,
            props: {
              ...component.props,
              qaId: QA_CHARGING_MODAL_TAB,
              onActiveIndexChangeParent: (index: number) => {
                triggerGAEvent(GaEvent.CONFIGURATOR_SELECT_TAB, {
                  tabName: stringSplitByHyphen(component.props.items[index].props.id),
                });
              },
            },
          };
        }
        return component;
      }),
    [data?.containers?.main, triggerGAEvent],
  );

  const getFooterContent = useCallback(() => data?.containers?.footer, [data]);

  return {
    headerContent: getHeaderContent(),
    mainContent: getMainContent(),
    footerContent: getFooterContent(),
  };
};

export default useCharging;
